import { useContext } from 'react';

import { OptionsContext } from '../contexts/OptionsContext';

export const useOptions = () => {
  const options = useContext(OptionsContext);
  return options;
};
